'use client'

import { useEffect, useRef } from 'react'
import { cn } from '@/lib/utils'
import type { AdsensePosition } from '@/lib/adsense'
import { initAdSlot } from '@/components/blog/ads/ad-init'

interface AdSlotProps {
  clientId: string
  slotId: string
  position: AdsensePosition
  className?: string
}

/**
 * Slot manual do AdSense. Só é renderizado quando o servidor já resolveu (getPublicAdsense) que a trava de
 * ambiente, o ADMIN, o Publisher ID, a posição e o Slot ID permitem — senão o componente nem existe na página.
 *
 * Sem espaço vazio: o <ins> não reserva altura; o rótulo "Publicidade" e o espaçamento só aparecem quando o
 * Google marcar o bloco como preenchido (data-ad-status="filled"); bloco não preenchido fica oculto.
 * Navegação: o pai dá uma `key` por rota/página, então cada slot é montado — e inicializado — uma vez por rota.
 */
export function AdSlot({ clientId, slotId, position, className }: AdSlotProps) {
  const insRef = useRef<HTMLModElement>(null)
  const initialized = useRef(false)

  useEffect(() => {
    if (initialized.current || !insRef.current) return
    initialized.current = true
    initAdSlot(insRef.current)
  }, [])

  return (
    <div data-ad-position={position} className={cn('group/ad has-[[data-ad-status=filled]]:my-10', className)}>
      <p className="mb-2 hidden text-center text-[11px] font-medium uppercase tracking-[0.14em] text-zinc-400 group-has-[[data-ad-status=filled]]/ad:block">
        Publicidade
      </p>
      <ins
        ref={insRef}
        className="adsbygoogle block data-[ad-status=unfilled]:hidden"
        data-ad-client={clientId}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  )
}
